import { inject, Injectable } from '@angular/core';
import { StateService } from '@uirouter/core';

import { FeaturesService } from 'src/app/components/plans/features.service';
import { UrlStateService } from './url-state.service';
import { UserAuthService } from './user-auth.service';
import { UserStateService } from './user-state.service';

export const NO_COMPANY_ROLE_ERROR = 'NO_COMPANY_ROLE';

@Injectable({
  providedIn: 'root',
})
export class CanAccessAppsService {
  private stateService = inject(StateService);
  private userStateService = inject(UserStateService);
  private userAuthService = inject(UserAuthService);
  private urlStateService = inject(UrlStateService);
  private featuresService = inject(FeaturesService);

  canAccessApps(
    signup?: boolean,
    allowReturn?: boolean,
    redirectTo?: string,
  ): Promise<void> {
    return this.userAuthService
      .authenticate(false)
      .then(() => {
        if (!this.userStateService.isRiseVisionUser()) {
          return Promise.reject();
        }

        if (
          !this.userStateService.hasAnyRole() &&
          !this.featuresService.isFeatureAvailable(
            FeaturesService.FEATURE_GRANULAR_USER_PERMISSIONS,
          )
        ) {
          return this.userAuthService.signOut(false).then(() => {
            this.stateService.go(
              'apps.auth.unauthorized',
              { authError: NO_COMPANY_ROLE_ERROR },
              { reload: true, location: 'replace' },
            );

            return Promise.reject(NO_COMPANY_ROLE_ERROR);
          });
        }
      })
      .catch((reason) => {
        if (reason === NO_COMPANY_ROLE_ERROR) {
          return Promise.reject(NO_COMPANY_ROLE_ERROR);
        }

        let newState: string | undefined;

        if (!this.userStateService.isLoggedIn()) {
          if (signup) {
            newState = 'apps.auth.createaccount';
          } else {
            newState = 'apps.auth.unauthorized';
          }
        } else if (this.stateService.get('apps.auth.unregistered')) {
          newState = 'apps.auth.unregistered';
        }

        const state = redirectTo ? redirectTo : this.urlStateService.get();

        if (newState) {
          this.stateService.go(
            newState,
            {
              state,
            },
            {
              reload: true,
              location: allowReturn ? true : 'replace',
            },
          );

          return Promise.reject('unauthenticated');
        }
      });
  }
}
